import styled from "styled-components";

const transitionTime = "1s";

export const ContainerSkeletonCard = styled.div<{ altura?: string }>`
  border-radius: 24px;
  width: 100%;
  height: ${(props) => props.altura || '35rem'};
  animation: pulsate ${transitionTime} ease-out infinite alternate;

  @keyframes pulsate {
    0% {
      background-color: ${(props) => props.theme.colors.skeleton1};
    }
    100% {
      background-color: ${(props) => props.theme.colors.skeleton2};
    }
  }

  @media (max-width: 1024px) {
    height: ${(props) => props.altura || '30rem'};
  }
`;
